"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsLoadingPayableById = exports.selectPayableById = exports.selectUniqAdjustmentUuids = void 0;
var uniq_1 = __importDefault(require("lodash/uniq"));
var reselect_1 = require("reselect");
var loading_1 = require("../loading");
var selectUniqAdjustmentUuids = function (state) {
    return (0, uniq_1.default)(state.payables.adjustments.map(function (a) { return a.createdBy; }));
};
exports.selectUniqAdjustmentUuids = selectUniqAdjustmentUuids;
var selectPayableById = function (state, id) { var _a; return (_a = state.payables.byId) === null || _a === void 0 ? void 0 : _a[id]; };
exports.selectPayableById = selectPayableById;
exports.selectIsLoadingPayableById = (0, reselect_1.createSelector)([loading_1.selectIsLoadingByResource], function (isLoadingByResource) { return isLoadingByResource[loading_1.Resource.PayableById]; });
